<template>
  <div class="workflow-page">
    <div class="page-header">
      <div>
        <h2>Workflow dos Processos</h2>
        <p>Acompanhamento gerencial das etapas e evolução dos processos</p>
      </div>

      <div class="header-actions">
        <button class="btn">Exportar</button>
        <button class="btn btn-primary">Atualizar Painel</button>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="card filters-card">
      <div class="filters-grid">
        <div class="field">
          <label>Município</label>
          <select v-model="filtros.municipio">
            <option value="">Todos</option>
            <option value="Araranguá">Araranguá</option>
            <option value="Sombrio">Sombrio</option>
            <option value="Turvo">Turvo</option>
          </select>
        </div>

        <div class="field">
          <label>Tipo de Processo</label>
          <select v-model="filtros.tipo">
            <option value="">Todos</option>
            <option value="Registro de Estabelecimento">Registro de Estabelecimento</option>
            <option value="Registro de Produto">Registro de Produto</option>
            <option value="Auto de Infração">Auto de Infração</option>
            <option value="Rótulo">Rótulo</option>
          </select>
        </div>

        <div class="field">
          <label>Status</label>
          <select v-model="filtros.status">
            <option value="">Todos</option>
            <option value="Em andamento">Em andamento</option>
            <option value="Com pendência">Com pendência</option>
            <option value="Concluído">Concluído</option>
            <option value="Atrasado">Atrasado</option>
          </select>
        </div>

        <div class="field">
          <label>Pesquisa</label>
          <input
            v-model="filtros.texto"
            type="text"
            placeholder="Número, estabelecimento ou responsável"
          />
        </div>
      </div>
    </div>

    <!-- KPIS -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <span class="kpi-label">Total de Processos</span>
        <strong class="kpi-value">{{ indicadores.total }}</strong>
      </div>

      <div class="kpi-card">
        <span class="kpi-label">Em Andamento</span>
        <strong class="kpi-value">{{ indicadores.emAndamento }}</strong>
      </div>

      <div class="kpi-card warning">
        <span class="kpi-label">Com Pendência</span>
        <strong class="kpi-value">{{ indicadores.comPendencia }}</strong>
      </div>

      <div class="kpi-card danger">
        <span class="kpi-label">Atrasados</span>
        <strong class="kpi-value">{{ indicadores.atrasados }}</strong>
      </div>

      <div class="kpi-card success">
        <span class="kpi-label">Concluídos</span>
        <strong class="kpi-value">{{ indicadores.concluidos }}</strong>
      </div>
    </div>

    <!-- ETAPAS -->
    <div class="card">
      <div class="card-header">
        <h3>Distribuição por Etapa</h3>
      </div>

      <div class="steps-board">
        <div class="step-column" v-for="etapa in etapasResumo" :key="etapa.nome">
          <div class="step-column-header">
            <strong>{{ etapa.nome }}</strong>
            <span>{{ etapa.total }}</span>
          </div>

          <div class="step-process-list">
            <div
              class="process-mini-card"
              v-for="proc in etapa.processos"
              :key="proc.id"
              @click="selecionarProcesso(proc)"
            >
              <div class="process-mini-title">{{ proc.numero }}</div>
              <div class="process-mini-subtitle">{{ proc.estabelecimento }}</div>
              <div class="process-mini-days">{{ proc.diasParado }} dia(s)</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA + DETALHE -->
    <div class="content-grid">
      <div class="card">
        <div class="card-header">
          <h3>Processos</h3>
        </div>

        <div class="table-wrapper">
          <table class="data-table">
            <thead>
              <tr>
                <th>Nº Processo</th>
                <th>Tipo</th>
                <th>Estabelecimento</th>
                <th>Município</th>
                <th>Etapa Atual</th>
                <th>Status</th>
                <th>Responsável</th>
                <th>Última Mov.</th>
                <th>Dias Parado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="proc in processosFiltrados"
                :key="proc.id"
                @click="selecionarProcesso(proc)"
                :class="{ selected: processoSelecionado && processoSelecionado.id === proc.id }"
              >
                <td>{{ proc.numero }}</td>
                <td>{{ proc.tipo }}</td>
                <td>{{ proc.estabelecimento }}</td>
                <td>{{ proc.municipio }}</td>
                <td>{{ proc.etapaAtual }}</td>
                <td>
                  <span class="status-badge" :class="badgeClass(proc.status)">
                    {{ proc.status }}
                  </span>
                </td>
                <td>{{ proc.responsavel }}</td>
                <td>{{ proc.ultimaMov }}</td>
                <td>{{ proc.diasParado }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card detail-card">
        <div class="card-header">
          <h3>Detalhes do Processo</h3>
        </div>

        <div v-if="processoSelecionado" class="process-detail">
          <div class="detail-summary">
            <div><strong>Processo:</strong> {{ processoSelecionado.numero }}</div>
            <div><strong>Tipo:</strong> {{ processoSelecionado.tipo }}</div>
            <div><strong>Estabelecimento:</strong> {{ processoSelecionado.estabelecimento }}</div>
            <div><strong>Município:</strong> {{ processoSelecionado.municipio }}</div>
            <div><strong>Etapa Atual:</strong> {{ processoSelecionado.etapaAtual }}</div>
            <div><strong>Status:</strong> {{ processoSelecionado.status }}</div>
          </div>

          <div class="timeline">
            <div
              class="timeline-item"
              v-for="(item, index) in processoSelecionado.historico"
              :key="index"
            >
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-title">{{ item.etapa }}</div>
                <div class="timeline-meta">
                  {{ item.data }} • {{ item.usuario }}
                </div>
                <div class="timeline-text">{{ item.obs }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="empty-state">
          Selecione um processo para visualizar o histórico resumido.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const filtros = ref({
  municipio: '',
  tipo: '',
  status: '',
  texto: ''
})

const processos = ref([
  {
    id: 1,
    numero: 'PROC-2026-0001',
    tipo: 'Registro de Estabelecimento',
    estabelecimento: 'Frigorífico Vale Sul',
    municipio: 'Araranguá',
    etapaAtual: 'Análise Documental',
    status: 'Em andamento',
    responsavel: 'Maria Souza',
    ultimaMov: '18/03/2026 14:10',
    diasParado: 2,
    historico: [
      { etapa: 'Protocolo', data: '12/03/2026 09:00', usuario: 'Empresa', obs: 'Solicitação enviada no portal.' },
      { etapa: 'Triagem', data: '13/03/2026 10:25', usuario: 'Carlos Lima', obs: 'Documentos encaminhados para análise.' },
      { etapa: 'Análise Documental', data: '18/03/2026 14:10', usuario: 'Maria Souza', obs: 'Em conferência dos documentos obrigatórios.' }
    ]
  },
  {
    id: 2,
    numero: 'PROC-2026-0002',
    tipo: 'Registro de Produto',
    estabelecimento: 'Laticínios Serra Azul',
    municipio: 'Sombrio',
    etapaAtual: 'Parecer Técnico',
    status: 'Com pendência',
    responsavel: 'João Martins',
    ultimaMov: '15/03/2026 11:40',
    diasParado: 5,
    historico: [
      { etapa: 'Protocolo', data: '08/03/2026 08:30', usuario: 'Empresa', obs: 'Pedido de registro de produto protocolado.' },
      { etapa: 'Análise Documental', data: '10/03/2026 16:00', usuario: 'Paula Ramos', obs: 'Documentação validada.' },
      { etapa: 'Parecer Técnico', data: '15/03/2026 11:40', usuario: 'João Martins', obs: 'Solicitada correção de memorial descritivo.' }
    ]
  },
  {
    id: 3,
    numero: 'PROC-2026-0003',
    tipo: 'Auto de Infração',
    estabelecimento: 'Abatedouro União',
    municipio: 'Turvo',
    etapaAtual: 'Defesa',
    status: 'Atrasado',
    responsavel: 'Ana Pereira',
    ultimaMov: '10/03/2026 09:15',
    diasParado: 10,
    historico: [
      { etapa: 'Lavratura', data: '05/03/2026 15:20', usuario: 'Fiscal Pedro', obs: 'Auto registrado no sistema.' },
      { etapa: 'Notificação', data: '06/03/2026 09:50', usuario: 'Fiscal Pedro', obs: 'Empresa notificada.' },
      { etapa: 'Defesa', data: '10/03/2026 09:15', usuario: 'Ana Pereira', obs: 'Aguardando manifestação do autuado.' }
    ]
  },
  {
    id: 4,
    numero: 'PROC-2026-0004',
    tipo: 'Rótulo',
    estabelecimento: 'Mel Puro do Sul',
    municipio: 'Araranguá',
    etapaAtual: 'Encerrado',
    status: 'Concluído',
    responsavel: 'Fernanda Luz',
    ultimaMov: '14/03/2026 17:05',
    diasParado: 0,
    historico: [
      { etapa: 'Protocolo', data: '07/03/2026 13:00', usuario: 'Empresa', obs: 'Solicitação iniciada.' },
      { etapa: 'Análise', data: '10/03/2026 10:10', usuario: 'Fernanda Luz', obs: 'Rótulo validado.' },
      { etapa: 'Encerrado', data: '14/03/2026 17:05', usuario: 'Fernanda Luz', obs: 'Processo concluído com deferimento.' }
    ]
  }
])

const processoSelecionado = ref(processos.value[0])

const processosFiltrados = computed(() => {
  return processos.value.filter((proc) => {
    const texto = filtros.value.texto.trim().toLowerCase()

    const atendeMunicipio = !filtros.value.municipio || proc.municipio === filtros.value.municipio
    const atendeTipo = !filtros.value.tipo || proc.tipo === filtros.value.tipo
    const atendeStatus = !filtros.value.status || proc.status === filtros.value.status
    const atendeTexto =
      !texto ||
      proc.numero.toLowerCase().includes(texto) ||
      proc.estabelecimento.toLowerCase().includes(texto) ||
      proc.responsavel.toLowerCase().includes(texto)

    return atendeMunicipio && atendeTipo && atendeStatus && atendeTexto
  })
})

const indicadores = computed(() => {
  const base = processosFiltrados.value

  return {
    total: base.length,
    emAndamento: base.filter(p => p.status === 'Em andamento').length,
    comPendencia: base.filter(p => p.status === 'Com pendência').length,
    atrasados: base.filter(p => p.status === 'Atrasado').length,
    concluidos: base.filter(p => p.status === 'Concluído').length
  }
})

const etapasPadrao = [
  'Protocolo',
  'Análise Documental',
  'Vistoria',
  'Parecer Técnico',
  'Decisão',
  'Defesa',
  'Encerrado'
]

const etapasResumo = computed(() => {
  return etapasPadrao.map((nomeEtapa) => {
    const lista = processosFiltrados.value
      .filter(proc => proc.etapaAtual === nomeEtapa)
      .map(proc => ({
        id: proc.id,
        numero: proc.numero,
        estabelecimento: proc.estabelecimento,
        diasParado: proc.diasParado,
        original: proc
      }))

    return {
      nome: nomeEtapa,
      total: lista.length,
      processos: lista.map(item => ({
        id: item.id,
        numero: item.numero,
        estabelecimento: item.estabelecimento,
        diasParado: item.diasParado,
        ...item.original
      }))
    }
  })
})

function selecionarProcesso(proc) {
  processoSelecionado.value = proc
}

function badgeClass(status) {
  if (status === 'Concluído') return 'success'
  if (status === 'Com pendência') return 'warning'
  if (status === 'Atrasado') return 'danger'
  return 'info'
}
</script>

<style scoped>
.workflow-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: #f5f7fb;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
}

.page-header p {
  margin: 4px 0 0;
  color: #667085;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.btn {
  border: 1px solid #d0d5dd;
  background: white;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
}

.btn-primary {
  background: #2563eb;
  color: white;
  border-color: #2563eb;
}

.card {
  background: white;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid #e5e7eb;
}

.card-header {
  margin-bottom: 12px;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 12px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field label {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
}

.field input,
.field select {
  height: 38px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 0 10px;
  outline: none;
  background: white;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(140px, 1fr));
  gap: 12px;
}

.kpi-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.kpi-card.warning {
  border-color: #f59e0b33;
}

.kpi-card.danger {
  border-color: #ef444433;
}

.kpi-card.success {
  border-color: #22c55e33;
}

.kpi-label {
  color: #667085;
  font-size: 13px;
}

.kpi-value {
  font-size: 28px;
  line-height: 1;
}

.steps-board {
  display: grid;
  grid-template-columns: repeat(7, minmax(180px, 1fr));
  gap: 12px;
  overflow-x: auto;
}

.step-column {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  min-height: 180px;
  padding: 10px;
}

.step-column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
}

.step-process-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.process-mini-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  transition: 0.2s ease;
}

.process-mini-card:hover {
  transform: translateY(-1px);
  border-color: #cbd5e1;
}

.process-mini-title {
  font-size: 13px;
  font-weight: 700;
}

.process-mini-subtitle {
  font-size: 12px;
  color: #475467;
  margin-top: 4px;
}

.process-mini-days {
  font-size: 11px;
  color: #98a2b3;
  margin-top: 6px;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
}

.table-wrapper {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.data-table th,
.data-table td {
  text-align: left;
  padding: 10px 8px;
  border-bottom: 1px solid #eef2f6;
  white-space: nowrap;
}

.data-table tbody tr {
  cursor: pointer;
  transition: 0.2s ease;
}

.data-table tbody tr:hover,
.data-table tbody tr.selected {
  background: #f8fafc;
}

.status-badge {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.info {
  background: #dbeafe;
  color: #1d4ed8;
}

.status-badge.warning {
  background: #fef3c7;
  color: #b45309;
}

.status-badge.danger {
  background: #fee2e2;
  color: #b42318;
}

.status-badge.success {
  background: #dcfce7;
  color: #15803d;
}

.detail-card {
  min-height: 420px;
}

.process-detail {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.detail-summary {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  font-size: 13px;
  color: #344054;
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-left: 2px solid #e5e7eb;
  padding-left: 14px;
  margin-left: 6px;
}

.timeline-item {
  position: relative;
}

.timeline-marker {
  position: absolute;
  left: -22px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2563eb;
}

.timeline-title {
  font-weight: 700;
  font-size: 13px;
}

.timeline-meta {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}

.timeline-text {
  font-size: 13px;
  color: #344054;
  margin-top: 4px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  color: #667085;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 1300px) {
  .filters-grid,
  .kpi-grid {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }

  .content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .filters-grid,
  .kpi-grid {
    grid-template-columns: 1fr;
  }
}
</style>